import {CardStyleRendererComponent} from './card-style-renderer/card-style-renderer.component';
import {CardStyleRendererObjectTypeComponent} from './card-style-renderer/card-style-renderer-type-object.component';
import {CardStyleRendererStringTypeComponent} from './card-style-renderer/card-style-renderer-type-string.component';
import {CardStyleRendererEnumTypeComponent} from './card-style-renderer/card-style-renderer-type-enum.component';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FormSchemaRendererComponent} from './form-schema-renderer.component';
import { NgModule } from '@angular/core';
import {SharedModule} from '../../shared.module';
import {CardStyleRendererArrayTypeComponent} from './card-style-renderer/card-style-renderer-type-array.component';
import { CardStyleRendererDateTypeComponent } from '@app/components/renderer/card-style-renderer/card-style-renderer-type-date.component';
import { ElementsModule } from '@app/components/elements/elements.module';
import { HasPatternDescriptionPipe } from '@app/components/renderer/card-style-renderer/has-pattern-description.pipe';

const CARD_STYLE_COMPONENTS = [
	CardStyleRendererComponent,
	CardStyleRendererObjectTypeComponent,
	CardStyleRendererStringTypeComponent,
	CardStyleRendererArrayTypeComponent,
	CardStyleRendererEnumTypeComponent,
	CardStyleRendererDateTypeComponent,
	FormSchemaRendererComponent,
	HasPatternDescriptionPipe
];

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		SharedModule,
		ElementsModule,
	],
	exports: [
		FormSchemaRendererComponent,
	],
	declarations: [
		...CARD_STYLE_COMPONENTS,
	],
})
export class JsonSchemaRendererModule {}
